export const USER_INFO = 'USER_INFO'
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO'
export const SWITCH_USER_INFO = 'SWITCH_USER_INFO'
export const LIST_STATE = 'LIST_STATE'
export const CLEAR_LIST_STATE = 'CLEAR_LIST_STATE'
export const CLASS_DATA = 'CLASS_DATA'
export const CLEAR_CLASS_DATA = 'CLEAR_CLASS_DATA'
